
import {CREATE_CHANGE_LOG ,
        UPDATE_CHANGE_LOG ,
      DELETE_CHANGE_LOG ,
      FETCH_CHANGE_LOGS,
      FETCH_RECENT_CHANGE_LOGS,
      GET_CHANGE_LOGS } from '../actions';
      import moment from 'moment';
      import config from "../config";


  
  const initialState = {
    selectedToDelete: null,
    selectedToEdit: null,
    setChangeLog : null ,
    updateChangeLog : null,
    changeLogs: [],
    recentChangeLogs :[],
    loading: false, 
    updateChangeLogError : null,
    setChangeLogError : null,
    changeLogsError : null,
    recentChangeLogsError : null,
    selectedToDeleteError : null,
    notifyChangeLog : "false" ,
    changeLog : null,
    getChangeLogError: null,
  };
  
  function changeLogReducer(state = initialState, action) {
    let selectedToDelete,
    changeLogs,
    recentChangeLogs,
    updateChangeLog,
    notifyChangeLog,
    setChangeLog,
    changeLog,
    getChangeLogError;
  
    switch (action.type) {
      case `${CREATE_CHANGE_LOG}_PENDING`:
      case `${UPDATE_CHANGE_LOG }_PENDING`:  
      case `${FETCH_CHANGE_LOGS}_PENDING`:
      case `${FETCH_RECENT_CHANGE_LOGS}_PENDING`:
      case `${DELETE_CHANGE_LOG}_PENDING`:
      case `${GET_CHANGE_LOGS}_PENDING`:
        return { ...state, loading: true,
          selectedToDeleteError : null,
          changeLogsError : null,
          setChangeLogError : null,
          updateChangeLogError : null,
        };
       
  
      case `${CREATE_CHANGE_LOG}_FULFILLED`:
        setChangeLog = action.payload.data;
          return { ...state, loading: false, setChangeLog };
      case `${UPDATE_CHANGE_LOG}_FULFILLED`:
        updateChangeLog = action.payload.data;
          return { ...state, loading: false, updateChangeLog }; 
      case `${FETCH_CHANGE_LOGS}_FULFILLED`:
        changeLogs = action.payload.data;
          return { ...state, loading: false, changeLogs };
      case `${FETCH_RECENT_CHANGE_LOGS}_FULFILLED`:       
              recentChangeLogs = action.payload.data;
              let notify = false ;
              if(recentChangeLogs.length > 0){             
                let currentDay = moment().format('YYYY-MM-DD');
                let latestReleaseDate = moment(recentChangeLogs[0].release_date).format('YYYY-MM-DD');
                let differnceInDays = moment(currentDay).diff(moment(latestReleaseDate), 'days');
                if(differnceInDays > config.changelogNotifyDays){
                  notify = false
                }else{
                  notify = true
                }
              }
      return { ...state, loading: false, notifyChangeLog : notify, recentChangeLogs };  

  
      case `${DELETE_CHANGE_LOG}_FULFILLED`:
        selectedToDelete = action.payload.data;
        return { ...state, loading: false, selectedToDelete }; 
      case `${GET_CHANGE_LOGS}_FULFILLED`:
          changeLog = action.payload.data;    
           return { ...state, loading: false, changeLog }; 
      case `${CREATE_CHANGE_LOG}_REJECTED`:
        return {...state, loading: false, setChangeLogError: action.payload.response.data, state: initialState };
      case `${UPDATE_CHANGE_LOG}_REJECTED`:
        return {...state, loading: false, updateChangeLogError: action.payload.response.data, state: initialState };
      case `${FETCH_CHANGE_LOGS}_REJECTED`:
        return {...state, loading: false, changeLogsError: action.payload.response.data, state: initialState };
        case `${FETCH_RECENT_CHANGE_LOGS}_REJECTED`:
          return {...state, loading: false, recentChangeLogsError: action.payload.response.data, state: initialState };  
      case `${DELETE_CHANGE_LOG}_REJECTED`:
        return {...state, loading: false, selectedToDeleteError: action.payload.response.data, state: initialState };
      case `${GET_CHANGE_LOGS}_REJECTED`:
          return {...state, loading: false, getChangeLogError: action.payload.response.data, state: initialState };
      default:
        return state;
    }
  }
  
  export default changeLogReducer;
  